import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../components/modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import LabelCustom from '../../../components/label-custom'
import { BsExclamationCircle } from 'react-icons/bs'
import {
  deleteSettingCertificateAPI,
  postSettingCertificateAPI,
  updateSettingCertificateAPI
} from '../../../services/setting/certificate'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import InputPriceCustom from '../../../components/custom/InputPriceCustom'
import SwalCustom from '../../../alert/swal-custom'
import UseCertificateLevel from '../../../hooks/use-cer-level'
import UseCertificateBrand from '../../../hooks/use-cer-brand'
import AutocompleteCustom from '../../../components/custom/autocomplete'

const schema = yup
  .object({
    certificate: yup.string().required('Please choose your certificate.'),
    amount: yup.string().required('Please choose your amount.'),
    group: yup.object().required('Please choose your group.'),
    category: yup.object().required('Please choose your category.'),
    brand: yup.object().required('Please choose your brand.'),
    certLevel: yup.object().required('Please choose your cert level.'),
    payLevel: yup.number().required('Please choose your pay level.')
  })
  .required()
export default function ModalNewCetificate({
  open,
  onCancel,
  fnGetData,
  data,
  optionCategory = [],
  optionGroup = []
}) {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [cartId, setCartId] = useState()

  const [bandId, setBandId] = useState()
  const optionBrand = UseCertificateBrand(cartId)

  const optionLevel = UseCertificateLevel(bandId)

  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    if (data) {
      setValue('certificate', data.paymentNameCer ?? '')
      setValue('amount', data.paymentCerAmounts ?? '')
      setValue('payLevel', data.paymentLevel)
      if (data.paymentCerBrandId) {
        setValue('brand', {
          value: data.paymentCerBrandId,
          label: data.paymentCerBrand
        })
        setBandId(data.paymentCerBrandId)
      }

      if (data.paymentCerLevelId) {
        setValue('certLevel', {
          value: data.paymentCerLevelId,
          label: data.paymentCerLevel
        })
      }

      setValue('group', {
        value: data.paymentCerGroupId,
        label: data.paymentCerGroup
      })

      setValue('category', {
        value: data.paymentCerCateId,
        label: data.paymentCertCategory
      })
      setCartId(data.paymentCerCateId)
    }
  }, [data, setValue])

  const onSubmit = async (d) => {
    const body = {
      paymentNameCer: d.certificate,
      paymentCerAmounts: +d.amount?.replace(/,/g, ''),

      paymentLevel: d.payLevel,
      paymentCerCateId: d.category.value,
      paymentCerBrandId: d.brand.value,
      paymentCerLevelId: d.certLevel.value,
      paymentCerGroupId: d.group.value
    }
    if (data) {
      sendAPI(
        updateSettingCertificateAPI(
          { ...body, paymentNameCerId: data.paymentNameCerId },
          body
        )
      )
    } else {
      sendAPI(postSettingCertificateAPI(body))
    }
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustomSuccess().then(() => {
        fnGetData()
        onCancel()
      })
    } else {
      Error_false(resp)
    }
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      confirmButtonColor: 'red',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = {
          paymentNameCerId: data.paymentNameCerId
        }
        sendAPI(deleteSettingCertificateAPI(body))
      }
    })
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>{data ? 'Update' : 'Add'} Cetificate</h5>
        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
          <Col xl={6}>
            <LabelCustom text={'Group'} />
            <Controller
              name={'group'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={optionGroup}
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                  }}
                />
              )}
            />
            {errors.group && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.group.message}
              </span>
            )}
          </Col>
          <Col xl={6}>
            <LabelCustom text={'Category'} />
            <Controller
              name={'category'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={optionCategory}
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                    setCartId(e.value)
                    setValue('brand', null)
                    setValue('certLevel', null)
                  }}
                />
              )}
            />
            {errors.category && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.category.message}
              </span>
            )}
          </Col>

          <Col xl={6}>
            <LabelCustom text={'Brand'} />
            <Controller
              name={'brand'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={optionBrand}
                  value={value}
                  onChange={(e) => {
                    setBandId(e.value)
                    setValue('certLevel', null)
                    onChange(e)
                  }}
                />
              )}
            />
            {errors.brand && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.brand.message}
              </span>
            )}
          </Col>
          <Col xl={6}>
            <LabelCustom text={'Cert Level'} />
            <Controller
              name={'certLevel'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <AutocompleteCustom
                  options={optionLevel}
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                  }}
                />
              )}
            />
            {errors.certLevel && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.certLevel.message}
              </span>
            )}
          </Col>

          <Col xl={12}>
            <LabelCustom text={'Cert Name'} />
            <Controller
              name={'certificate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Form.Control value={value} onChange={onChange} />
              )}
            />
            {errors.certificate && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.certificate.message}
              </span>
            )}
          </Col>

          <Col xl={6}>
            <LabelCustom text={'Pay Level'} />
            <Controller
              name={'payLevel'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <Form.Control
                  min={0}
                  maxLength={100}
                  type="number"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            {errors.payLevel && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.payLevel.message}
              </span>
            )}
          </Col>

          <Col xl={6}>
            <LabelCustom text={'Amount'} />
            <Controller
              name={'amount'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <InputPriceCustom value={value} onChange={onChange} />
              )}
            />
            {errors.amount && (
              <span className="text-danger small fw-light">
                <BsExclamationCircle /> {errors.amount.message}
              </span>
            )}
          </Col>
          <Col xl={12} className="d-flex justify-content-center g-3 gap-3 mt-4">
            <Button variant="light" className="px-4" onClick={onCancel}>
              Close
            </Button>
            {data && (
              <Button className="px-4" variant="danger" onClick={fnDelete}>
                Delete
              </Button>
            )}
            <Button disabled={isSubmit} type="submit" className="px-4">
              Submit{isSubmit && 'ting...'}
            </Button>
          </Col>
        </Form>
      </div>
    </ModalCustom>
  )
}
